import React from "react";

// - Libraries
import { useTransition, animated } from "react-spring";

// - Variables
import { ANIMATION_MODAL } from "./config";

// - Components
import ModalEventHandler from "./modal-event-handler";
import ModalNavigation from "./modal-navigation";

function Modal({ open, children, toggle, center = false, className = "" }) {
    const transition = useTransition(open, null, ANIMATION_MODAL);

    return transition.map(
        ({ item, key, props }) =>
            item && (
                <animated.div
                    key={key}
                    className={`modal ${
                        center && "flex flex-center flex-align"
                    }`}
                    style={props}
                >
                    <ModalNavigation toggle={toggle} />

                    {children}
                    <ModalEventHandler toggle={toggle} />
                </animated.div>
            )
    );
}

export default Modal;
